/**
 * Implementation of Monitor Region page
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React from "react";
import StepTwo from "../../../components/CreateMonitor/StepTwo";
import ConnectedWorld from "../../../images/connected-world.svg";

export default function MonitorRegion() {

  return (
    <div className="flex">
      <div className="w-1/3 bg-accent rounded-tl-xl rounded-bl-xl flex flex-col pt-28 items-center">
        <img src={ConnectedWorld} width={200} className="mb-4"/>
        <h1 className="text-2xl text-white mb-4">Global Coverage</h1>
        <p className="text-center text-white">We monitor your website globally across 9 global locations so that you can be available worldwide.</p>
      </div>
      <div className="flex-1 p-8">

        <h1 className="text-2xl my-4 text-center">Select Region</h1>
        <StepTwo />
      </div>
    </div>
  )
}